import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './imagePreview.scss'

const ImagePreview = forwardRef((props, ref) => {
	const { image, format, background } = props

	const componentClass = 'c-image-preview'
	const cssClasses = classNames(
		componentClass,
		image && `${componentClass}--background-${background}`,
		format && `${componentClass}--format-${format}`
	)

	return (
		<div ref={ref} className={cssClasses}>
			{image && <img src={`${process.env.STORAGE}/${image}`} alt="" />}
		</div>
	)
})

ImagePreview.propTypes = {
	image: PropTypes.string,
	format: PropTypes.oneOf(['squared', 'panorama']),
	background: PropTypes.oneOf(['default', 'light', 'dark']),
}

ImagePreview.defaultProps = {
	image: null,
	format: 'squared',
	background: 'default',
}

export default ImagePreview
